module.exports = __webpack_public_path__ + "img/arabica-bean.7b47b071.png";